import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { SoftphoneProvider } from './context/SoftphoneContext';
import WebphoneGate from './components/dialer/WebphoneGate';

import LoginPage from './components/auth/LoginPage';
import Layout from './components/layout/Layout';
import DashboardPage from './components/dashboard/DashboardPage';
import ExtensionsPage from './components/extensions/ExtensionsPage';
import TrunksPage from './components/trunks/TrunksPage';
import QueuesPage from './components/queues/QueuesPage';
import IVRPage from './components/ivr/IVRPage';
import RingGroupsPage from './components/ringgroups/RingGroupsPage';
import VoicemailPage from './components/voicemail/VoicemailPage';
import CDRPage from './components/cdr/CDRPage';
import EventLogPage from './components/events/EventLogPage';
import RecordingsPage from './components/recordings/RecordingsPage';
import DialplanPage from './components/dialplan/DialplanPage';
import ConferencesPage from './components/conferences/ConferencesPage';
import PhonebookPage from './components/phonebook/PhonebookPage';
import UsersPage from './components/users/UsersPage';
import SettingsPage from './components/settings/SettingsPage';
import SystemPage from './components/system/SystemPage';
import MonitorPage from './components/monitor/MonitorPage';
import WebphonePage from './components/dialer/WebphonePage';
import IntegrationsPage from './components/integrations/IntegrationsPage';
import AppsPage from './components/apps/AppsPage';
import MessagingPage from './components/messaging/MessagingPage';

function ProtectedRoute({ children, roles = [] }) {
  const { user, token } = useAuthStore();
  if (!token || !user) return <Navigate to="/login" replace />;
  if (roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/webphone" element={
          <ProtectedRoute>
            <WebphoneGate>
              <SoftphoneProvider>
                <WebphonePage />
              </SoftphoneProvider>
            </WebphoneGate>
          </ProtectedRoute>
        } />
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<DashboardPage />} />
          <Route path="extensions" element={<ExtensionsPage />} />
          <Route path="trunks" element={
            <ProtectedRoute roles={['admin','superadmin']}>
              <TrunksPage />
            </ProtectedRoute>
          } />
          <Route path="queues" element={<QueuesPage />} />
          <Route path="ivr" element={
            <ProtectedRoute roles={['admin','superadmin']}>
              <IVRPage />
            </ProtectedRoute>
          } />
          <Route path="ring-groups" element={
            <ProtectedRoute roles={['admin','superadmin']}>
              <RingGroupsPage />
            </ProtectedRoute>
          } />
          <Route path="voicemail" element={<VoicemailPage />} />
          <Route path="cdr" element={<CDRPage />} />
          <Route path="events" element={<EventLogPage />} />
          <Route path="recordings" element={<RecordingsPage />} />
          <Route path="dialplan" element={
            <ProtectedRoute roles={['admin','superadmin']}>
              <DialplanPage />
            </ProtectedRoute>
          } />
          <Route path="conferences" element={<ConferencesPage />} />
          <Route path="phonebook" element={<PhonebookPage />} />
          <Route path="users" element={
            <ProtectedRoute roles={['admin','superadmin']}>
              <UsersPage />
            </ProtectedRoute>
          } />
          <Route path="settings" element={
            <ProtectedRoute roles={['admin','superadmin']}>
              <SettingsPage />
            </ProtectedRoute>
          } />
          <Route path="system" element={
            <ProtectedRoute roles={['admin','superadmin']}>
              <SystemPage />
            </ProtectedRoute>
          } />
          <Route path="integrations" element={
            <ProtectedRoute roles={['admin','superadmin']}>
              <IntegrationsPage />
            </ProtectedRoute>
          } />
          <Route path="apps" element={<AppsPage />} />
          <Route path="messaging" element={
            <ProtectedRoute roles={['admin','superadmin','supervisor','agent']}>
              <MessagingPage />
            </ProtectedRoute>
          } />
          <Route path="monitor" element={
            <ProtectedRoute roles={['admin','superadmin']}>
              <MonitorPage />
            </ProtectedRoute>
          } />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
